const url = ( value ) => {
    var urlRegEx = /^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9‌@:%_\+.~#?&=]*)/;
    return urlRegEx.test( value );
};

const email = ( value ) => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test( value );
};

const password = ( value ) => {
    var passRegEx = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,})$/;
    return passRegEx.test( value );
};

const standardSlug = ( value ) => {
    return !( /[\<\>\#\%\"\{\}\|\^\[\]\`\;\/\?\:\@\&\=\+\$\,\s]/.test( value ) );
};

const userSlug = ( value ) => {
    return !( /^(admin|app|phantom|puppeteer|sitemap|extension|embed|l)$/i.test( value ) );
};

const required = ( value ) => {
    return value !== undefined ? undefined : 'Required field';
};

const youtube = ( value ) => {
    if( !value ) {
        return undefined;
    }
    var p = /^[^\.]*\.+(?:youtu\.be\/|youtube\.com\/)?.*(?:embed\/|v\/|watch\?v=|watch\?.+&v=)((?:\w|-){11})/i;
    return p.test( value ) ? undefined : 'Unrecognized YouTube URL';
};

const reduxStandard = {
    email: ( value ) => {
        return email( value ) ? undefined : 'Invalid e-mail address';
    },
    slug: ( value ) => {
        if( !standardSlug( value ) ) {
            return 'Slug contains invalid characters';
        }
        if( !userSlug( value ) ) {
            return 'Slug is reserved by the system';
        }
        return undefined;
    },
};



export default {
    required,
    url,
    email,
    password,
    reduxStandard,
    youtube,
};
